import { connect } from 'react-redux';
import {
  createDraftOrders,
  createAutoOrders,
  deleteOrders,
  autoPlanningAction,
  setSelectedRowAction,
  createAutoTickets,
  publishToSapQuickAction,
} from './toolbar-dynamic-actions-actions';
import DynamicActions from '../components/toolbar-dynamic-actions';
import { setFullScreen } from '../../../planning-board/containers/planning-board-actions';
import {
  updateFilters,
} from './../../../worklist/containers/worklist-actions';
import {
  getCategoryInfo,
} from './../../../tickets/containers/form/ticket-form-actions';

const mapStateToProps = state => ({
  generalError: state.dynamicToolbar.generalError,
  isCreating: state.dynamicToolbar.isCreating,
  singleErrors: state.dynamicToolbar.singleErrors,
  successCreateIds: state.dynamicToolbar.successCreateIds,
  autoTotal: state.dynamicToolbar.autoTotal,
  autoFaulty: state.dynamicToolbar.autoFaulty,
  autoDraftFailed: state.dynamicToolbar.autoDraftFailed,
  autoCreateFailed: state.dynamicToolbar.autoCreateFailed,
  errors: state.dynamicToolbar.errors,
  deleteSuccess: state.dynamicToolbar.deleteSuccess,
  createSuccess: state.dynamicToolbar.createSuccess,
  autoPlanningInfo: state.dynamicToolbar.autoPlanningInfo,
  selectedRowAction: state.dynamicToolbar.selectedRowAction,
  isFullScreen: state.planningBoard.fullScreen,
  questions: state.ticketForm.categoryInfo.conclusionWizard,
  tags: state.ticketForm.categoryInfo.conclusionTags,
  planningBlocks: state.dynamicToolbar.planningBlocks,
});

const mapDispatchToProps = {
  createDraftOrders,
  createAutoOrders,
  createAutoTickets,
  deleteOrders,
  autoPlanningAction,
  setSelectedRowAction,
  setIsFullScreen: setFullScreen,
  updateFilters,
  getCategoryInfo,
  publishToSapQuickAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DynamicActions);
